

import React, { ChangeEvent, useState } from "react";
import {
    Box,
    Button,
    TextField,
    Typography,
    Chip,
    FormControlLabel,
    RadioGroup,
    Radio,
    Input,
    Autocomplete,
    CardMedia,
    MenuItem,
    Select,
    SelectChangeEvent,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';
import CloseIcon from "@mui/icons-material/Close";
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';

const AddBlog = () => {
    const navigate = useNavigate();

    const [contentType, setContentType] = useState("article");
    const [category, setCategory] = useState("Maker Stories");
    const [title, setTitle] = useState("");
    const [subtitle, setSubtitle] = useState("");
    const [authorName, setAuthorName] = useState("");
    const [authorImage, setAuthorImage] = useState("");
    const [readTime, setReadTime] = useState("");
    const [publishDate, setPublishDate] = useState("");

    const [metaTitle, setMetaTitle] = useState("");
    const [keywords, setKeywords] = useState<string[]>([]);
    const [linkedProducts, setLinkedProducts] = useState<string[]>([]);
    const [linkedVendors, setLinkedVendors] = useState<string[]>([]);

    const [featuredImage, setFeaturedImage] = useState<string>("");

    // Multi-section state
    const [sections, setSections] = useState([
        { id: Date.now(), title: "", description: "", image: "", fileName: "" }
    ]);

    const handleAddSection = () => {
        setSections([...sections, { id: Date.now(), title: "", description: "", image: "", fileName: "" }]);
    };

    const handleRemoveSection = (id: number) => {
        setSections(sections.filter(s => s.id !== id));
    };

    const handleSectionChange = (id: number, field: string, value: string) => {
        setSections(sections.map(s => s.id === id ? { ...s, [field]: value } : s));
    };

    const handleCreateWithAI = (type: 'title' | 'subtitle' | 'section') => {
        if (type === 'title') setTitle("The Revival of Traditional Embroidery in Modern Fashion");
        if (type === 'subtitle') setSubtitle("How UAE artisans are bringing centuries-old embroidery techniques to contemporary luxury fashion.");
    };

    const handleSubmit = () => {
        console.log({
            contentType,
            category,
            title,
            subtitle,
            authorName,
            readTime,
            publishDate,
            sections,
            linkedProducts,
            linkedVendors,
            metaTitle,
            keywords
        });
        navigate("/blogs");
    };

    return (
        <div className="add_journal_page">
            <div className="main_title d_flex justify-between align-center">
                <div>
                    <h1>Add New Journal Post</h1>
                    <p>
                        <button onClick={() => navigate("/dashboard")}>Dashboard</button> - <button onClick={() => navigate("/blogs")}>Journals</button> - Add Post
                    </p>
                </div>
            </div>
            <div className="table_flex">
                <div className="lt">
                    <div className="cards">
                        <div className="form">
                            <div className="gap_p">

                                {/* ===== Content Type Selection ===== */}
                                <div className="control_group w_100">
                                    <label>Content Type & Format <span className="req">*</span></label>
                                    <RadioGroup
                                        row
                                        value={contentType}
                                        onChange={(e) => setContentType(e.target.value)}
                                    >
                                        <FormControlLabel value="article" control={<Radio />} label="Standard Article" />
                                        <FormControlLabel value="video" control={<Radio />} label="Video / Reel" />
                                        <FormControlLabel value="audio" control={<Radio />} label="Audio Podcast" />
                                        <FormControlLabel value="spotlight" control={<Radio />} label="Maker Spotlight" />
                                    </RadioGroup>
                                </div>

                                {/* ===== Video/Media URL (Conditional) ===== */}
                                {(contentType === 'video' || contentType === 'audio') && (
                                    <div className="control_group w_100">
                                        <label htmlFor="mediaUrl">{contentType === 'video' ? 'Video URL / Reel link' : 'Audio / Podcast Link'}</label>
                                        <TextField id="mediaUrl" fullWidth placeholder="Paste link here..." />
                                    </div>
                                )}

                                {/* ===== Header Metadata ===== */}
                                <div className="title_inner">
                                    <h2>Journal Header & Metadata</h2>
                                </div>

                             
                                <div className="control_group w_100">
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <label htmlFor="blog-title">Main Post Title <span className="req">*</span></label>
                                        <Button size="small" startIcon={<AutoAwesomeIcon />} onClick={() => handleCreateWithAI('title')} sx={{ textTransform: 'none', color: '#D3B88C' }}>Suggest Title</Button>
                                    </Box>
                                    <TextField
                                        placeholder="Enter a compelling title"
                                        fullWidth
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                        inputProps={{ id: "blog-title" }}
                                    />
                                </div>

                                <div className="control_group w_100">
                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <label htmlFor="blog-subtitle">Subtitle / Hook <span className="req">*</span></label>
                                        <Button size="small" startIcon={<AutoAwesomeIcon />} onClick={() => handleCreateWithAI('subtitle')} sx={{ textTransform: 'none', color: '#D3B88C' }}>Refine Hook</Button>
                                    </Box>
                                    <TextField
                                        placeholder="e.g. How UAE artisans are bringing techniques to fashion..."
                                        fullWidth
                                        multiline
                                        rows={2}
                                        value={subtitle}
                                        onChange={(e) => setSubtitle(e.target.value)}
                                        inputProps={{ id: "blog-subtitle" }}
                                    />
                                </div>

                                <div className="control_group w_33">
                                    <label htmlFor="blog-author-name">Author Name</label>
                                    <TextField
                                        fullWidth
                                        placeholder="Fatima Al-Hashimi"
                                        value={authorName}
                                        onChange={(e) => setAuthorName(e.target.value)}
                                        inputProps={{ id: "blog-author-name" }}
                                    />
                                </div>

                                <div className="control_group w_33">
                                    <label htmlFor="blog-read-time">Read Time</label>
                                    <TextField
                                        fullWidth
                                        placeholder="e.g. 7 min read"
                                        value={readTime}
                                        onChange={(e) => setReadTime(e.target.value)}
                                        inputProps={{ id: "blog-read-time" }}
                                    />
                                </div>

                                <div className="control_group w_33">
                                    <label htmlFor="blog-publish-date">Publish Date</label>
                                    <TextField
                                        fullWidth
                                        placeholder="October 31, 2025"
                                        value={publishDate}
                                        onChange={(e) => setPublishDate(e.target.value)}
                                        inputProps={{ id: "blog-publish-date" }}
                                    />
                                </div>

                                {/* ===== Featured Image ===== */}
                                <div className="control_group w_100">
                                    <label>Featured Image (Main Thumbnail)</label>
                                    {featuredImage ? (
                                        <div className="upload_image">
                                            <div className="upload_image_holder no_radius main_featured">
                                                <figure>
                                                    <CardMedia component="img" image={featuredImage} alt="Featured" />
                                                </figure>
                                                <CloseIcon onClick={() => setFeaturedImage("")} />
                                            </div>
                                        </div>
                                    ) : (
                                        <label className="upload_image" htmlFor="featured-img">
                                            <Input
                                                sx={{ display: "none" }}
                                                id="featured-img"
                                                type="file"
                                                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                                    const files = e.target.files;
                                                    if (files && files[0]) setFeaturedImage(URL.createObjectURL(files[0]));
                                                }}
                                            />
                                            <span className="upload_image_holder no_radius">
                                                <figure className="add_img">
                                                    <img src="/static/images/placeholder.png" alt="placeholder" />
                                                    <span className="upload_img_icon">
                                                        <img src="/static/images/edit2_icon.svg" alt="edit icon" />
                                                    </span>
                                                </figure>
                                            </span>
                                        </label>
                                    )}
                                </div>

                                {/* ===== Dynamic Story Sections ===== */}
                                <div className="title_inner d_flex justify-between align-center">
                                    <h2>Story Sections</h2>
                                    <Button
                                        variant="outlined"
                                        size="small"
                                        onClick={handleAddSection}
                                        sx={{ borderColor: '#D3B88C', color: '#D3B88C', textTransform: 'none' }}
                                    >
                                        + Add New Section
                                    </Button>
                                </div>

                                {sections.map((section, index) => (
                                    <div key={section.id} className="blog_section_item" style={{ border: '1px solid #eee', padding: '15px', borderRadius: '8px', marginBottom: '20px', position: 'relative' }}>
                                        {sections.length > 1 && (
                                            <Button
                                                size="small"
                                                color="error"
                                                onClick={() => handleRemoveSection(section.id)}
                                                style={{ position: 'absolute', right: '10px', top: '10px', minWidth: 'auto' }}
                                            >
                                                <CloseIcon fontSize="small" />
                                            </Button>
                                        )}
                                        <Typography variant="caption" sx={{ color: '#999', mb: 1, display: 'block' }}>Section #{index + 1}</Typography>

                                        <div className="control_group w_100">
                                            <label htmlFor={`section-title-${section.id}`}>Section Title</label>
                                            <TextField
                                                fullWidth
                                                placeholder="Sub-heading for this part of the story"
                                                value={section.title}
                                                onChange={(e) => handleSectionChange(section.id, 'title', e.target.value)}
                                                inputProps={{ id: `section-title-${section.id}` }}
                                            />
                                        </div>

                                        <div className="control_group w_100">
                                            <label htmlFor={`section-desc-${section.id}`}>Section Description</label>
                                            <TextField
                                                fullWidth
                                                multiline
                                                rows={4}
                                                placeholder="Write the content for this section..."
                                                value={section.description}
                                                onChange={(e) => handleSectionChange(section.id, 'description', e.target.value)}
                                                inputProps={{ id: `section-desc-${section.id}` }}
                                            />
                                        </div>

                                        <div className="control_group w_100">
                                            <label>Section Image (Optional)</label>
                                            {section.image ? (
                                                <div className="upload_image">
                                                    <div className="upload_image_holder no_radius' border_dashed">
                                                        <figure>
                                                            <CardMedia component="img" image={section.image} alt="Section" />
                                                        </figure>
                                                        <CloseIcon onClick={() => handleSectionChange(section.id, 'image', "")} />
                                                    </div>
                                                </div>
                                            ) : (
                                                <label className="upload_image" htmlFor={`section-img-${section.id}`}>
                                                    <Input
                                                        sx={{ display: "none" }}
                                                        id={`section-img-${section.id}`}
                                                        type="file"
                                                        onChange={(e: ChangeEvent<HTMLInputElement>) => {
                                                            const files = e.target.files;
                                                            if (files && files[0]) handleSectionChange(section.id, 'image', URL.createObjectURL(files[0]));
                                                        }}
                                                    />
                                                    <span className="upload_image_holder no_radius border_dashed">
                                                        <figure className="add_img" style={{ width: '60px', height: '60px' }}>
                                                            <img src="/static/images/placeholder.png" alt="placeholder" />
                                                        </figure>
                                                        <span style={{ fontSize: '12px', color: '#666' }}>Upload Section Image</span>
                                                    </span>
                                                </label>
                                            )}
                                        </div>
                                    </div>
                                ))}

                                {/* ===== Commerce Linking ===== */}
                                <div className="title_inner">
                                    <h2 style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <LinkOutlinedIcon fontSize="small" /> Link to Commerce
                                    </h2>
                                </div>

                                <div className="control_group w_50">
                                    <label htmlFor="link-products">Link Products</label>
                                    <Autocomplete
                                        id="link-products"
                                        multiple
                                        options={["Handmade Vase", "Organic Cotton Rug", "Artisanal Candle"]}
                                        renderInput={(params) => <TextField {...params} placeholder="Select products" />}
                                        onChange={(_, v) => setLinkedProducts(v)}
                                    />
                                </div>

                                <div className="control_group w_50">
                                    <label htmlFor="link-vendors">Link Vendors</label>
                                    <Autocomplete
                                        id="link-vendors"
                                        multiple
                                        options={["Sarah's Pottery", "EcoFabrics", "CandleCraft"]}
                                        renderInput={(params) => <TextField {...params} placeholder="Select vendors" />}
                                        onChange={(_, v) => setLinkedVendors(v)}
                                    />
                                </div>

                                {/* ===== SEO & Discoverability ===== */}
                                <div className="title_inner">
                                    <h2>SEO & Discoverability</h2>
                                </div>

                                <div className="control_group w_50">
                                    <label htmlFor="metaTitle">Meta Title</label>
                                    <TextField id="metaTitle" fullWidth placeholder="SEO title (max 60 chars)" value={metaTitle} onChange={(e) => setMetaTitle(e.target.value)} />
                                </div>

                                <div className="control_group w_50">
                                    <label htmlFor="focus-keywords">Focus Keywords</label>
                                    <Autocomplete
                                        id="focus-keywords"
                                        multiple
                                        freeSolo
                                        options={[]}
                                        renderTags={(value, getTagProps) =>
                                            value.map((option, index) => (
                                                <Chip label={option} {...getTagProps({ index })} />
                                            ))
                                        }
                                        renderInput={(params) => <TextField {...params} placeholder="Add keywords" />}
                                        onChange={(_, v) => setKeywords(v)}
                                    />
                                </div>

                            </div>

                            <div className="form_btn d_flex gap_10 mt_20">
                                <Button className="btn btn_primary" onClick={handleSubmit}>
                                    Publish to Journal
                                </Button>
                                <Button variant="outlined" onClick={() => navigate("/blogs")} className="btn_outline">
                                    Save as Draft
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="rt">
                    <div className="ai_content_ideas_wrapper">
                        {/* Featured Idea Card */}
                        <div className="content_idea_card">
                            <div className="card_image">
                                <img src="/static/images/placeholder.png" alt="Decor" />
                            </div>
                            <h3>AI Content Ideas</h3>
                            <div className="idea_content">
                                <LightbulbOutlinedIcon className="icon" style={{ fontSize: 16, color: '#d97706' }} />
                                <div className="text">
                                    <h4>5 Ramadan gifting ideas for a modern home</h4>
                                    <p>Highlight our premium home decor pieces that align with Ramadan aesthetic.</p>
                                </div>
                            </div>
                            <button className="generate_btn">
                                <AutoAwesomeIcon style={{ fontSize: 14 }} /> Generate Ideas
                            </button>
                        </div>

                        {/* List Item */}
                        <div className="idea_list_item">
                            <div className="idea_header">
                                <LightbulbOutlinedIcon style={{ fontSize: 16, color: '#d97706' }} />
                                <h3>AI Content Ideas</h3>
                            </div>
                            <div className="idea_content">
                                <h4>5 Ramadan gifting ideas for a modern home</h4>
                                <p>Highlight our premium home decor pieces that align with Ramadan aesthetic.</p>
                            </div>
                        </div>
                    </div>
                    <div className="ai_panel">
                        <h4>AI Insights</h4>

                        <div className="ai_alert warning">
                            <span className="icon">⚠️</span>
                            <p>
                                <b>7 SKUs</b> need immediate attention
                            </p>
                        </div>

                        <div className="ai_alert danger">
                            <span className="icon">⛔</span>
                            <p>
                                <b>3 SKUs</b> have zero sales in 30 days
                            </p>
                        </div>

                        <small className="ai_update">
                            Next updated ETA: <b>May 5, 2024</b>
                        </small>

                        <div className="ai_sku_list">
                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_002</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>

                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_010</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default AddBlog;
